import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <main className="pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-outfit text-4xl font-semibold tracking-tight mb-8" data-testid="terms-title">
            Terms of Service
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-8 text-muted-foreground">
            <p className="text-sm">Last updated: January 2026</p>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">1. Service Agreement</h2>
              <p>
                By using ShipTesla's vehicle transport services, you agree to these Terms of Service. 
                ShipTesla operates as a vehicle transport broker, connecting customers with licensed 
                and insured auto transport carriers.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">2. Booking & Deposits</h2>
              <p>
                A deposit is required to secure your transport booking. The deposit amount varies by 
                transport type ($199 for open carrier, $299 for enclosed carrier). This deposit is:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Fully refundable until dispatch confirmation</li>
                <li>Non-refundable after carrier dispatch confirmation</li>
                <li>Applied to your total transport cost</li>
              </ul>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">3. Pricing & Payment</h2>
              <p>
                All quoted prices are estimates based on current market conditions. Final pricing 
                is confirmed at booking. Exact pickup or delivery times are not guaranteed. The remaining balance after deposit is due at vehicle 
                delivery, payable directly to the carrier via cash, cashier's check, or money order.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">4. Vehicle Requirements</h2>
              <p>
                Vehicles must be in operable condition (running and driveable). We currently do not 
                transport inoperable vehicles. All personal items must be removed from the vehicle 
                prior to transport. ShipTesla is not responsible for items left in vehicles.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">5. Insurance Coverage</h2>
              <p>
                All carriers in our network maintain cargo insurance with minimum coverage of $100,000 
                per vehicle. Additional insurance documentation is available upon request. Any claims 
                must be noted on the Bill of Lading at delivery and reported within 24 hours.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">6. Cancellation Policy</h2>
              <p>
                Cancellations requested before carrier dispatch will receive a full deposit refund. 
                Cancellations after carrier dispatch may be subject to fees. If a carrier cancels, 
                we will work to find an alternative carrier or provide a full refund.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">7. Limitation of Liability</h2>
              <p>
                ShipTesla acts as a broker and is not liable for damages occurring during transport. 
                All claims should be directed to the carrier's insurance. Our liability is limited 
                to the deposit amount paid.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">8. Service Area</h2>
              <p>
                We currently service the 48 continental United States only. Alaska, Hawaii, and 
                international destinations are not available at this time.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">9. Contact</h2>
              <p>
                For questions about these terms, please contact us at support@shiptesla.com or 
                call 1-800-555-1234.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
